var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { hasMany, belongsTo, attr } from '@ember-data/model';
import { mapBy } from 'ilios-common/utils/array-helpers';
let Term = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = belongsTo('vocabulary', {
  async: true,
  inverse: 'terms'
}), _dec4 = belongsTo('term', {
  inverse: 'children',
  async: true
}), _dec5 = hasMany('term', {
  inverse: 'parent',
  async: true
}), _dec6 = hasMany('program-year', {
  async: true,
  inverse: 'terms'
}), _dec7 = hasMany('session', {
  async: true,
  inverse: 'terms'
}), _dec8 = hasMany('course', {
  async: true,
  inverse: 'terms'
}), _dec9 = hasMany('aamc-resource-type', {
  async: true,
  inverse: null
}), _dec10 = attr('boolean'), _dec11 = hasMany('course-objective', {
  async: true,
  inverse: 'terms'
}), _dec12 = hasMany('program-year-objective', {
  async: true,
  inverse: 'terms'
}), _dec13 = hasMany('session-objective', {
  async: true,
  inverse: 'terms'
}), _class = class Term extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "title", _descriptor, this);
    _initializerDefineProperty(this, "description", _descriptor2, this);
    _initializerDefineProperty(this, "vocabulary", _descriptor3, this);
    _initializerDefineProperty(this, "parent", _descriptor4, this);
    _initializerDefineProperty(this, "children", _descriptor5, this);
    _initializerDefineProperty(this, "programYears", _descriptor6, this);
    _initializerDefineProperty(this, "sessions", _descriptor7, this);
    _initializerDefineProperty(this, "courses", _descriptor8, this);
    _initializerDefineProperty(this, "aamcResourceTypes", _descriptor9, this);
    _initializerDefineProperty(this, "active", _descriptor10, this);
    _initializerDefineProperty(this, "courseObjectives", _descriptor11, this);
    _initializerDefineProperty(this, "programYearObjectives", _descriptor12, this);
    _initializerDefineProperty(this, "sessionObjectives", _descriptor13, this);
  }
  get associatedLengths() {
    return [this.hasMany('programYears').ids().length, this.hasMany('courses').ids().length, this.hasMany('sessions').ids().length, this.hasMany('programYearObjectives').ids().length, this.hasMany('courseObjectives').ids().length, this.hasMany('sessionObjectives').ids().length];
  }
  get totalAssociations() {
    return this.associatedLengths.reduce((prev, curr) => prev + curr);
  }
  get hasAssociations() {
    return !!this.totalAssociations;
  }
  get isTopLevel() {
    return !this.belongsTo('parent').id();
  }
  get childCount() {
    return this.hasMany('children').ids().length;
  }
  get hasChildren() {
    return !!this.childCount;
  }

  /**
   * A list of parent terms of this term, sorted by ancestry (oldest ancestor first).
   */
  async getAllParents() {
    const parent = await this.parent;
    if (!parent) {
      return [];
    }
    const allParents = await parent.getAllParents();
    return [...allParents, parent];
  }

  /**
   * A list of parent terms titles of this term, sorted by ancestry (oldest ancestor first).
   */
  async getAllParentTitles() {
    const parent = await this.parent;
    if (!parent) {
      return [];
    }
    const parents = await parent.getAllParents();
    const titles = mapBy(parents, 'title');
    return [...titles, parent.title];
  }

  /**
   * A list of parent terms titles of this term, including this term's title as its last item.
   */
  async getTitleWithParentTitles() {
    const parentTitles = await this.getAllParentTitles();
    if (!parentTitles.length) {
      return this.title;
    }
    return parentTitles.join(' > ') + ' > ' + this.title;
  }
  async getAllDescendants() {
    const children = await this.children;
    const childrenDescendants = await Promise.all(children.map(child => child.getAllDescendants()));
    const flatChildrenDescendants = childrenDescendants.reduce((array, set) => {
      return [...array, ...set];
    }, []);
    return [...children, ...flatChildrenDescendants];
  }

  /**
   * A list of descendant terms titles of this term, including this term's title as its last item.
   */
  async getTitleWithDescendantTitles() {
    const allDescendants = await this.getAllDescendants();
    const allDescendantTitles = mapBy(allDescendants, 'title');
    if (!allDescendantTitles.length) {
      return this.title;
    }
    return allDescendantTitles.join(' > ') + ' > ' + this.title;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "title", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "vocabulary", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "parent", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "children", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "programYears", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "sessions", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "courses", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "aamcResourceTypes", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "active", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "courseObjectives", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "programYearObjectives", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "sessionObjectives", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Term as default };